import React from 'react'
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';

function Footer() {
  return (
    <div>
      <div className='w-full bg-[#F7F7F7] h-[10vh] flex justify-center items-center'>
      <a href="mailto:gargvishal3564@gmail.com"><EmailIcon/></a> 
      <div className='m-2'>|</div>
      <a href="https://www.linkedin.com/in/vishal-garg-3564vg/" target='_blank'><LinkedInIcon/></a>
      <div className='m-2'>|</div>
      <a href="https://github.com/visha064" target='_blank'><GitHubIcon/></a>
    </div>
     </div>
  )
}

export default Footer
